var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from "styled-components";
export var LinkButton = function (_a) {
    var children = _a.children, linkType = _a.linkType, props = __rest(_a, ["children", "linkType"]);
    if (linkType === "primary") {
        return (_jsx(PrimaryStyledLink, __assign({}, props, { className: "btn font-weight-bold px-9 py-4 my-3 mx-4" }, { children: children })));
    }
    else if (linkType == "secondary") {
        return _jsx(SecondaryStyledLink, __assign({}, props, { children: children }));
    }
    else if (linkType == "plain") {
        return _jsx(PlainStyledLink, __assign({}, props, { children: children }));
    }
    return null;
};
var PrimaryStyledLink = styled.a(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n   {\n    background-color: #1867be;\n    color: white;\n  }\n\n  :hover {\n    background-color: #187de4;\n    color: white;\n  }\n"], ["\n   {\n    background-color: #1867be;\n    color: white;\n  }\n\n  :hover {\n    background-color: #187de4;\n    color: white;\n  }\n"])));
var SecondaryStyledLink = styled.a(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n   {\n    background-color: #e4e6ef !important;\n    color: #7e8299;\n  }\n\n  :hover {\n    background-color: #d7dae7 !important;\n    color: #7e8299;\n  }\n"], ["\n   {\n    background-color: #e4e6ef !important;\n    color: #7e8299;\n  }\n\n  :hover {\n    background-color: #d7dae7 !important;\n    color: #7e8299;\n  }\n"])));
var PlainStyledLink = styled.a(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n   {\n    color: #1867be;\n  }\n\n  :hover {\n    color: #187de4;\n  }\n"], ["\n   {\n    color: #1867be;\n  }\n\n  :hover {\n    color: #187de4;\n  }\n"])));
var templateObject_1, templateObject_2, templateObject_3;
